import { useEffect, useState } from "react";
import BigToggle from "../../../helperComponents/BigToggle";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import { useTranslation } from "react-i18next";

export default function EmployeePicker({ value, onChange }) {
  const [items, setItems] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    serverLine.get("/admin/employees").then(setItems);
  }, []);

  if (!items) return <LoadingSection />;

  return (
    <BigToggle
      title={t("adminPageActivityPickEmployee")}
      options={items.map((item) => getItem(item))}
    ></BigToggle>
  );

  function getItem(item) {
    return {
      onClick: () => {
        onChange(item._id);
      },
      isSelected: value === item._id,
      label: `${item.name}`,
    };
  }
}
